import { ReactNode } from 'react';
import classNames from 'classnames';

import PopupContent from '~/components/PopupContent';

import styles from './CardPopupContainer.module.scss';

type TCardPopupContainerProps = {
  children: ReactNode;
  className?: string;
  onClose?: () => void;
  contentElementId?: string;
};

export function CardPopupContainer({
  children,
  className,
  ...props
}: TCardPopupContainerProps): JSX.Element {
  return (
    <PopupContent
      className={classNames(styles.container, className)}
      {...props}
    >
      {children}
    </PopupContent>
  );
}
